<template>
  <div class="container">
    <div class="row width_full">
      <div class="col_12">
        <div class="common_subtitle pb_20">
          <h3 class="mb_0">Settings</h3>
        </div>
        <div :class="['row mt_20']" >
          <div class="col_3" >
            <div :class="['form-group', {'has_error': errorFor('logo')}]">
              <label>Logo</label>
              <input type="file" class="form_global" ref="imageInput" accept="image/png, image/gif, image/jpeg" @input="onFileChange($event, 'logo', 'image')">
              <template v-if="errors && errors.logo">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.logo" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div class="form-group">
              <img v-if="setting && setting.logo" :src="setting.logo" alt=""   width="150">
            </div>
            <div class="d_flex_end">
              <button  class="btn btn_common width_full" @click="submit('logo')">Save <i v-if="sendReq === 'logo'" class="fas fa-circle-notch fa-spin ml_5"  ></i></button>
            </div>
          </div>
          <div class="col_3" >
            <div :class="['form-group', {'has_error': errorFor('poppup_image')}]">
              <label>Popup Image</label>
              <input type="file" class="form_global" ref="imageInput" accept="image/png, image/gif, image/jpeg, image/web, image/jpg" @input="onFileChange($event, 'poppup_image', 'image')">
              <template v-if="errors && errors.poppup_image">
                <small class="d_flex_start mb_5" v-for="(error, errorIndex) in errors.poppup_image" :key="'error_status_'+errorIndex">{{error}}</small>
              </template>
            </div>
            <div :class="['form-group', {'has_error': errorFor('popup_link')}]">
              <input type="text" class="form_global" placeholder="https://example.com" v-model="newForm.popup_link" >
            </div>
            <div class="form-group">
              <img v-if="setting && setting.poppup_image" :src="setting.poppup_image" alt=""   width="150">
            </div>
            <div class="d_flex_end">
              <button  class="btn btn_common width_full" @click="submit('poppup_image')">Save <i v-if="sendReq === 'poppup_image'" class="fas fa-circle-notch fa-spin ml_5"  ></i></button>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data(){
    return{
      setting: null,
      newForm:{
        column: '',
        popup_link: '',
        file: '',
        type: '',
      },
      sendReq: null
    }
  },
  created() {
    this.axios.get('settings').then((response)=>{
      this.setting = response.data.data
      this.newForm.popup_link = this.setting.popup_link
    })
  },
  methods:{
    onFileChange(event, column, type){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;
      let file = event.target.files[0]
      this.newForm.file = file
      this.newForm.type = type
      this.newForm.column = column
    },
    submit(column) {
      this.sendReq = column
      this.errors = null;
      let formData = new FormData()
      Object.keys(this.newForm).forEach(key => {
        formData.append(key, this.newForm[key] ? this.newForm[key] : '');
      })
      this.axios.post('/settings', formData)
          .then((response) => {
            this.setting = response.data.data
            this.sendReq = ''
            this.showSuccessMsg("Added Successfully!");
          })
          .catch((err) => {
            this.errors = err.response.data.errors
          })
          .finally(() => {
            this.sendReq = ''
          })
    },
  }
}
</script>